<template>
  <dl class="myo_search_list">
    <dt>{{ i18n.myoffice.MyMember.division }}</dt>
    <dd>
      <v-select :options="division" :reduce="value => value.id" :modelValue="selection" @update:modelValue="get_reg_type" :clearable="false" class="custom-vselect " />
    </dd>
  </dl>
</template>

<script>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
    name: "divisionForm",
    components : {
      vSelect
    },
    props : {
      reg_type  : {
        type    : String,
        default : 'R'
      },
    },
    data: () => ({
        i18n      : window.i18n,
        selection : "R",
        division  : [ { "id": "P", "label": i18n.myoffice.PlacementSponsor || "Placement Sponsor" }, { "id": "R", "label": i18n.myoffice.EnrollmentSponsor || "Enrollment Sponsor" } ],
    }),
    mounted() {
      this.selection = this.reg_type;
    },
    methods: {
      get_reg_type(value) {
        this.selection = value;
        this.$emit('get_reg_type', value);
      },
    }

}
</script>

<style scoped>
    .custom-vselect {
        z-index: 1 !important;
    }
</style>
